import type { BundlePageData } from "@/lib/bundlePage";
import type { CartItem } from "@/stores/cartStore";
import { getOvaBundleKind } from "./ovaBundleContent";

/** Build the complete set or nothing; never silently add a partial bundle. */
export function buildOvaBundleCartLines(data: BundlePageData): Omit<CartItem, "lineId">[] | null {
  const kind = getOvaBundleKind(data.items.map((item) => item.handle));
  if (!kind || getOvaBundleKind(data.rule.matchHandles) !== kind) return null;
  if (!Number.isSafeInteger(data.qty) || data.qty < 1 || data.qty > Number.MAX_SAFE_INTEGER / 60) return null;
  if (!Number.isFinite(data.total) || data.total <= 0) return null;
  const lines: Omit<CartItem, "lineId">[] = [];
  for (const product of data.items) {
    const variant = product.variants.edges[0]?.node;
    if (!variant?.id || variant.availableForSale !== true ||
        !Number.isFinite(Number(variant.price.amount)) || Number(variant.price.amount) <= 0 ||
        variant.price.currencyCode !== "INR") return null;
    lines.push({
      variantId: variant.id,
      productHandle: product.handle,
      productTitle: product.title,
      imageUrl: product.images.edges[0]?.node.url ?? null,
      price: variant.price,
      quantity: data.qty,
    });
  }
  if (new Set(lines.map((line) => line.variantId)).size !== lines.length) return null;
  return lines;
}
